import { useEffect, useState } from 'react';
import { connect } from 'react-redux';

import { ToggleSwitch } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import PropTypes from 'prop-types';
import PubSub from 'pubsub-js';

import notificationActions from '../actions/notificationActions';
import * as types from '../constants';
import { checkForNotificationPermission } from '../utilities/auth';
import * as analyticsConst from '../utilities/constants';
import NotificationPreferencesTile from './components/PreferenceTile';

import './styles/index.css';

export const util = {
  getDescriptionBasedOnToggleType: null,
  getElementBasedOnToggleType: null,
  getTileInfo: null,
  enableNotificationsToggleHandler: null,
  toggleHandler: null
};

export function NotificationPreferences({ ...props }) {
  const { config, updateEnableNotificationsToggle, updateToggleButton, groups, userPreferences = {} } = props;
  const {
    notificationPreferences: { labels: notificationPreferencesLabels, toggleOptions }
  } = config;

  let channelsData = {};
  if (Object.keys(userPreferences).length) {
    const {
      data: {
        userPreferences: { channels }
      }
    } = userPreferences;
    channelsData = channels && channels.length && channels[0];
  }
  const [toggleEnableNotification, setToggleEnableNotification] = useState(channelsData.isChecked);

  useEffect(() => {
    if (Object.keys(channelsData).length) {
      setToggleEnableNotification(channelsData.isChecked);
    }
  }, [channelsData]);

  util.getDescriptionBasedOnToggleType = toggleState => ({
    [types.CONTRACTS]: toggleState
      ? analyticsConst.NOTIFICATION_PREFERENCES_CONTRACTS_DESCP_ACTIVE
      : analyticsConst.NOTIFICATION_PREFERENCES_CONTRACTS_DESCP_DEACTIVE,
    [types.ORDERS]: toggleState
      ? analyticsConst.NOTIFICATION_PREFERENCES_ORDERS_DESCP_ACTIVE
      : analyticsConst.NOTIFICATION_PREFERENCES_ORDERS_DESCP_DEACTIVE,
    [types.DOCUMENTS]: toggleState
      ? analyticsConst.NOTIFICATION_PREFERENCES_DOCUMENT_DESCP_ACTIVE
      : analyticsConst.NOTIFICATION_PREFERENCES_DOCUMENT_DESCP_DEACTIVE
  });

  util.getElementBasedOnToggleType = toggleState => ({
    [types.CONTRACTS]: toggleState
      ? analyticsConst.NOTIFICATION_PREFERENCES_CONTRACTS_ELMT_ACTIVE
      : analyticsConst.NOTIFICATION_PREFERENCES_CONTRACTS_ELMT_DEACTIVE,
    [types.ORDERS]: toggleState
      ? analyticsConst.NOTIFICATION_PREFERENCES_ORDERS_ELMT_ACTIVE
      : analyticsConst.NOTIFICATION_PREFERENCES_ORDERS_ELMT_DEACTIVE,
    [types.DOCUMENTS]: toggleState
      ? analyticsConst.NOTIFICATION_PREFERENCES_DOCUMENT_ELMT_ACTIVE
      : analyticsConst.NOTIFICATION_PREFERENCES_DOCUMENT_ELMT_DEACTIVE
  });

  util.enableNotificationsToggleHandler = e => {
    updateEnableNotificationsToggle(userPreferences, channelsData.frequencies, e);
    setToggleEnableNotification(e);
    const analyticsData = {
      description: e
        ? analyticsConst.NOTIFICATIONS_PREFERENCES_DESCP_ACTIVE
        : analyticsConst.NOTIFICATIONS_PREFERENCES_DESCP_DEACTIVATED,
      event: analyticsConst.NOTIFICATIONS_CLICK_ACTION_EVENT,
      pageName: analyticsConst.NOTIFICATIONS_PAGE_NAME,
      element: {
        name: e
          ? analyticsConst.NOTIFICATIONS_PREFERENCES_ENABLE_NOTIFICATIONS_ELMT_ACTIVE
          : analyticsConst.NOTIFICATIONS_PREFERENCES_ENABLE_NOTIFICATIONS_ELMT_DEACTIVATED
      },
      capability: analyticsConst.NOTIFICATIONS_CAPABILITY
    };
    PubSub.publish(analyticsConst.NOTIFICATIONS_PREFERENCES_ANALYTICS, analyticsData);
  };

  util.toggleHandler = (e, id, toggleType) => {
    if (toggleEnableNotification) {
      updateToggleButton(userPreferences, channelsData.frequencies, toggleEnableNotification, e, id);
      const analyticsData = {
        description: util.getDescriptionBasedOnToggleType(e)[toggleType],
        event: analyticsConst.NOTIFICATIONS_CLICK_ACTION_EVENT,
        pageName: analyticsConst.NOTIFICATIONS_PAGE_NAME,
        capability: analyticsConst.NOTIFICATIONS_CAPABILITY,
        element: { name: util.getElementBasedOnToggleType(e)[toggleType] }
      };
      PubSub.publish(analyticsConst.NOTIFICATIONS_PREFERENCES_ANALYTICS, analyticsData);
    }
  };

  util.getTileInfo = type => {
    if (toggleOptions && toggleOptions.length) {
      return toggleOptions.find(item => item.apiKey === type);
    }
    return {};
  };

  return (
    <div className="notification-preferences-wrapper">
      <div className="notification-preferences-content">
        <div className="heading-content">
          <div className="heading-message">
            <p>{notificationPreferencesLabels.headingMessage}</p>
          </div>
          <div className="sub-heading-message">
            <p>{notificationPreferencesLabels.subHeadingMessage}</p>
          </div>
        </div>
        <div className="enable-notification-preferences">
          <div className="enable-toggle-switch">
            <ToggleSwitch
              id={channelsData.id}
              onChange={e => util.enableNotificationsToggleHandler(e)}
              small
              checked={toggleEnableNotification}
            />
          </div>
          <div className="enable-toggle-switch-label">
            <h5>{notificationPreferencesLabels.portalNotifications}</h5>
          </div>
        </div>
        <div className="notification-preferences-toggle-content-wrapper">
          {channelsData &&
            channelsData.entities &&
            channelsData.entities.length &&
            channelsData.entities.map(
              (item, key) =>
                checkForNotificationPermission(item.name, groups) && (
                  <NotificationPreferencesTile
                    key={key}
                    isNotificationPreferencesEnabled={toggleEnableNotification}
                    toggleHandler={util.toggleHandler}
                    tileData={item}
                    toggleOptions={util.getTileInfo(item.name)}
                  />
                )
            )}
        </div>
      </div>
    </div>
  );
}

NotificationPreferences.defaultProps = {
  userPreferences: {
    data: {
      channels: [
        {
          isChecked: false,
          frequencies: [],
          entities: []
        }
      ]
    }
  },
  groups: []
};

NotificationPreferences.propTypes = {
  config: PropTypes.instanceOf(Object).isRequired,
  userPreferences: PropTypes.shape({
    data: PropTypes.shape({
      channels: PropTypes.arrayOf(
        PropTypes.shape({
          isChecked: PropTypes.bool,
          frequencies: PropTypes.instanceOf(Array),
          entities: PropTypes.instanceOf(Array)
        })
      ),
      userPreferences: PropTypes.instanceOf(Object)
    })
  }),
  updateEnableNotificationsToggle: PropTypes.func.isRequired,
  updateToggleButton: PropTypes.func.isRequired,
  groups: PropTypes.instanceOf(Object)
};
const mapDispatchToProps = dispatch => ({
  updateEnableNotificationsToggle: (userPreferences, frequencies, isNotificationPreferencesEnabled, id) =>
    dispatch(
      notificationActions.updateEnableNotificationsToggle(
        userPreferences,
        frequencies,
        isNotificationPreferencesEnabled,
        id
      )
    ),
  updateToggleButton: (userPreferences, frequencies, isNotificationPreferencesEnabled, toggleState, id) =>
    dispatch(
      notificationActions.updateToggle(userPreferences, frequencies, isNotificationPreferencesEnabled, toggleState, id)
    )
});

export default connect(null, mapDispatchToProps)(NotificationPreferences);
